import { useNavigate, useRouteError } from 'react-router-dom'
import { Result } from 'antd'
import React, { useEffect } from 'react'

export default function ErrorPage(props) {
  const error: any = useRouteError()
  const navigate = useNavigate()

  useEffect(() => {
    console.log('page error ==>>', props, error)
  }, [])

  const goBack = () => {
    navigate('/')
  }

  return (
    <div style={{ textAlign: 'center', height: '100%', backgroundColor: 'rgb(246, 248, 251)', borderRadius: '12px' }}>
      <Result
        status="500"
        title="500"
        subTitle="对不起，出了点问题."
        // extra={
        //   <Button type="primary" onClick={goBack}>
        //     返回首页
        //   </Button>
        // }
      />
    </div>
  )
}
